import React, {useEffect, useState} from 'react';
import {BreadcrumbVisual} from "./breadcrumb-visual/BreadcrumbVisual";

export function Breadcrumb({elements, ranked, className}) {
  const [initialElements] = useState(elements)
  const [breadCrumbElements, setBreadCrumbElements] = useState(elements)
  const [rank, setRank] = useState(elements.at(-1).name)

  const handleSearchStateChange = (event) => {
    setRank(new URL(window.location.href).href.split('/').at(-1))
  }

  useEffect(() => {
    window.addEventListener('searchStateChange', handleSearchStateChange);

    // Cleanup: remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('searchStateChange', handleSearchStateChange);
    };
  }, []);

  useEffect(() => {
      if(rank.includes('+') || rank === "ranked") {
        setBreadCrumbElements((oldState) => {
          const newState = [...initialElements]
          newState.at(-1).name = ''
          newState.at(-1).url = null
          return newState
        })
      }
      else if (ranked) {
        setBreadCrumbElements((oldState) => {
          const newState = [...initialElements]
          newState.at(-1).name = rank
          newState.at(-1).url = `/league-of-legends/lol-account/category/ranked/${rank}`
          return newState
        })
      }
  }, [rank]);

  return <BreadcrumbVisual breadCrumbElements={breadCrumbElements} className={className}/>
}
